// Query hook - lista ofert przypisanych do transakcji
// GET /api/ui/sales-crm/deals/{id}/offers

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetDealOffersResponse } from 'api/types/deals';

const getDealOffers = (id: number): Promise<IGetDealOffersResponse> =>
  axios.get(`/sales-crm/deals/${id}/offers`);

export const useGetDealOffers = (
  id: number,
  options?: UseQueryOptions<IGetDealOffersResponse, IError>,
) =>
  useQuery<IGetDealOffersResponse, IError>(
    ['sales-crm-deal-offers', id],
    () => getDealOffers(id),
    {
      enabled: id > 0,
      ...options,
    },
  );
